import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import './SuspendAccountModal.scss';

interface SuspendAccountModalProps {
  show: boolean;
  onHide: () => void;
  customerName?: string;
  onConfirm?: (reason: string) => void;
}

const SuspendAccountModal: React.FC<SuspendAccountModalProps> = ({
  show,
  onHide,
  customerName = 'Joshua Kimmich',
  onConfirm
}) => {
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm(reason);
    }
    setReason('');
    onHide();
  };

  const handleCancel = () => {
    setReason('');
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="suspend-account-modal"
    >
      <Modal.Body>
        <h2 className="modal-title">
          Are you sure to suspend {customerName}'s account?
        </h2>

        <div className="reason-input-wrapper">
          <textarea
            className="reason-textarea"
            placeholder="Why do you want to cancel this account?"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={6}
          />
        </div>

        <div className="modal-actions">
          <button className="btn btn-confirm" onClick={handleConfirm}>
            YES
          </button>
          <button className="btn btn-cancel" onClick={handleCancel}>
            NO
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SuspendAccountModal;
